import { statusToDocumentUploadMap } from "../../../constants/statusToDocMap/docUploadMap";
import { DocumentsStoreedInLocalStorage } from "../../../data-model/docsStorageInLocalStorage";
import {
  AuthOnFile,
  GeneralOrderDetails,
  JCodeDetails,
} from "../../../data-model/medicalPaOrdersModel";
import { DocumentTypesForOrder } from "../../../enums/documentTypes";
import {
  UserGeneralInfoContextKeys,
  UserStore,
} from "../../../store/UserGeneralInfoStore";
import { getAllJCodesFromAuthOnFile } from "./existingDocsToLs";

// TypeScript interfaces for the CPT codes data structure
export interface JCodeObject {
  jCode: string;
  isDocPresent: { [key: string]: boolean };
  identifier: string;
  drugs: string;
}

// interface StatusToJCodesMap {
//   [status: string]: JCodeObject[];
// }

export const saveJCodeDocsToLocalStorage = (
  generalOrderDetails: GeneralOrderDetails,
  authOnFileDetails: AuthOnFile,
) => {
  try {
    if (!authOnFileDetails?.entries) {
      return;
    }
    const documentsBasedOnType: any = Object.values(
      DocumentTypesForOrder,
    ).reduce(
      (acc, docType) => {
        acc[docType] = [];
        return acc;
      },
      {} as Record<DocumentTypesForOrder, DocumentsStoreedInLocalStorage[]>,
    );

    const allJCodes = getAllJCodesFromAuthOnFile(authOnFileDetails);
    allJCodes?.forEach((jCode) => {
      return prepareJCodeDocsForLS(jCode, documentsBasedOnType);
    });

    UserStore.setItem(
      `${UserGeneralInfoContextKeys.JCODE_DOCS}_${generalOrderDetails?.order_id}`,
      documentsBasedOnType,
    );
  } catch (error) {
    console.error("Error saving CPT codes to local storage:", error);
  }
};

const prepareJCodeDocsForLS = (
  jCodes: JCodeDetails,
  documentsBasedOnType: any,
) => {
  const getAllDocForAnAuthStatus =
    statusToDocumentUploadMap[jCodes?.auth_status || ""]?.documents || [];

  const jCodeDocs = jCodes?.documents || [];

  getAllDocForAnAuthStatus.forEach((doc: any) => {
    const isDocPresent = jCodeDocs.some(
      (jCodeDoc: any) =>
        jCodeDoc.doc_type === doc.doc_type &&
        jCodeDoc?.doc_path !== "" &&
        jCodeDoc?.doc_path !== null,
    );

    documentsBasedOnType[doc.doc_type] = [
      ...(documentsBasedOnType[doc.doc_type] || []),
      {
        isDocPresent: isDocPresent,
        docType: doc.doc_type,
        docPath:
          jCodeDocs.find((jCodeDoc: any) => jCodeDoc.doc_type === doc.doc_type)
            ?.doc_path || "",
        jcodeIdentifier: jCodes?.id || "",
        jcodeDescription: jCodes?.medicine_name || jCodes?.description || "",
        lastUpdatedAt:
          jCodeDocs.find((jCodeDoc: any) => jCodeDoc.doc_type === doc.doc_type)
            ?.doc_upload_date || "",
      } as DocumentsStoreedInLocalStorage,
    ];
  });

  return documentsBasedOnType;
};
